import ModalTitleButton from "../../SubDashboard/ModalTitleButton/ModalTitleButton";

function DeleteContent({ closeModal }) {
    return (
        <>
            <div className="fixed top-0 left-0 w-screen h-screen bg-black opacity-40"></div>
            <div className="fixed top-1/4 left-1/4 w-2/5 h-2/6 bg-white rounded-lg shadow">
                <ModalTitleButton
                    text="حذف"
                    closeModal={closeModal}
                >
                    <div className="flex flex-col justify-evenly">
                        <div className="flex flex-row-reverse items-center justify-center my-10">
                            <img src="/image/icon/deleteIcon.png" className="w-16 ml-4" />
                            <div className="flex flex-col text-center">
                                <p className="t-purpleDark text-lg">آیا از حذف محتوای اضافه شده به کانال اطمینان دارید؟</p>
                                <p className="text-xs text-slate-400 mt-2">لطفا در حذف محتوای انتخاب شده دقت نمایید</p>
                            </div>
                        </div>
                    </div>
                </ModalTitleButton>
            </div>
        </>
    )
}
export default DeleteContent;